module.exports = __webpack_public_path__ + "img/Frame_17.1db9409b.png";